import succuessIcon from '../../../../../assets/circle-check.svg'

export const Success = () => {
  return <div className='flex flex-col w-full p-10 justify-center items-center space-y-5'>
    <img alt='bank' src={succuessIcon} className='w-20' />
    <div className='space-y-3'>
      <div className='text-lg text-center text-slate-gray font-bold leading-6'>
        Account Created Successfully
      </div>
      <div className='text-sm text-center text-slate-gray'>
        You will receive an email for each initiated payment shortly!
      </div>
    </div>
  </div>;
}